import {
  pnm_sub_title,
  pnm_title,
  pnm_title_mobile,
} from '@porterin/feature/src/shared/core/constants/FareEstimateFormStore';
import { MODAL_CLOSE_TIMEOUT_NONE } from '@porterin/feature/src/shared/modal/domain/entities/ModalEntities';
import styles from '@porterin/feature/src/shared/modal/view/styles/FareEstimateModal.module.scss';
import React from 'react';
import ReactModal from 'react-modal';

import input_field_styles from '../styles/PnMFareEstimateInputModal.module.scss';
import modal_form_styles from '../styles/PnMFareEstimateModal.module.scss';

import { make as PnMFareEstimateFormCmp } from './PnMFareEstimateFormCmp.mjs';
import PnMFareEstimateModalLayoutCmp from './PnMFareEstimateModalLayoutCmp';

interface PnMFareEstimateModalCmpProps {
  modal_state: boolean;
  close_modal: () => void;
  show_house_field: boolean;
}

function PnMFareEstimateModalCmp({
  modal_state,
  close_modal,
  show_house_field,
}: Readonly<PnMFareEstimateModalCmpProps>): React.ReactElement {
  return (
    <ReactModal
      isOpen={modal_state}
      onRequestClose={close_modal}
      closeTimeoutMS={MODAL_CLOSE_TIMEOUT_NONE}
      overlayClassName={styles['overlay']}
      className={styles['modal-container']}
      ariaHideApp={false}
      shouldCloseOnOverlayClick
    >
      <PnMFareEstimateModalLayoutCmp
        title={pnm_title}
        sub_title={pnm_sub_title}
        title_mobile={pnm_title_mobile}
        close_modal={close_modal}
      >
        <PnMFareEstimateFormCmp
          styles={modal_form_styles}
          input_field_styles={input_field_styles}
          show_house_size={show_house_field}
        />
      </PnMFareEstimateModalLayoutCmp>
    </ReactModal>
  );
}

export default PnMFareEstimateModalCmp;
